import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios";



export const loadEmployees = async () => {
  try {
    const response = await Axios.get('employees');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadEmployee = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/employee');
        const requestData = await response.data;
        return {...requestData, employee: {}};
        
      default:
        const respnse = await Axios.get('employees/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useEmployeeAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('employees', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('employee_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('employees/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('employee_response', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useEmployeeAPI;


